/**
 * The mini program's spinner, to the pixel: 15px, 2px border in currentColor
 * with a transparent top, 0.7s linear. `.qflow-spinner` in app.css.
 */
export function Spinner({ className = '' }: { className?: string }) {
  return (
    <span
      className={`inline-block h-[15px] w-[15px] shrink-0 animate-[spin_0.7s_linear_infinite] rounded-full border-2 border-current border-t-transparent ${className}`}
    />
  )
}

export default function LoadingState({ label }: { label?: string }) {
  return (
    <div className="flex flex-col items-center gap-3 py-16 text-gold">
      <Spinner />
      {label ? <span className="text-13 text-muted">{label}</span> : null}
    </div>
  )
}
